<template>
    <div>
        <v-row>
            <v-col>
                <v-sheet class="mt-10 pa-5 center" elevation="3" max-width="770">
                    <v-row>
                        <v-col>
                            <i18n
                                tag="h4"
                                path="synchrony_standard.results.existing.account.finish.header"
                                class="body-1-lg mb-2 primary--text"
                            />
                            <i18n
                                tag="p"
                                path="synchrony_standard.results.existing.account.finish.body"
                                class="mb-16 body_1"
                            />
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
    </div>
</template>

<script setup lang="ts">
    import { goto } from "@/util/navigation"
    import { onBeforeMount, onMounted, ref } from "vue"

    const idleTimer = ref<number>()
    const idleMillis = 30_000

    onMounted(() => {
        idleTimer.value = setTimeout(() => {
            goto({ path: "/idle" })
        }, idleMillis)
    })

    onBeforeMount(() => {
        clearTimeout(idleTimer.value)
    })
</script>
